import React, { ImgHTMLAttributes, useState, useEffect, useRef } from "react";
import styled from "@emotion/styled";

interface GifPlayerProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
	url: string;
	alt?: string;
	repeatDuration?: number;
}

export const GifPlayer: React.FC<GifPlayerProps> = ({
	url,
	alt = "GIF animation",
	repeatDuration = 2000,
	...imgProps
}) => {
	const [timestamp, setTimestamp] = useState(Date.now());
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setTimestamp(Date.now());
		}, repeatDuration);

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const gifUrl = `${url}${url.includes("?") ? "&" : "?"}t=${timestamp}`;

	return (
		<GifContainer>
			<GifImage src={gifUrl} alt={alt} {...imgProps} />
		</GifContainer>
	);
};

const GifContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: inline-block;
`;

const GifImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	max-width: 100%;
`;
